import { FormSettingsType } from '../components/Form';
import * as yup from 'yup';

const validationSchema = yup.object().shape({

    name: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .max(80, 'MAXLENGTH')
})

export const PermissionSearchForm: FormSettingsType = {
    submitOnKeyEnter: true,
    fields: [
        {
            type: 'search',
            name: 'unitsSearch',
            placeholder: 'form.placeholders.auditsSearch',
            addorn: {
                rightIcon: 'search',
            },
        },
    ],
};

const permissionFormValidationSchema = yup.object().shape({

    name: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .max(40, 'MAXLENGTH')
})

export const PermissionForm: FormSettingsType = {
    validationSchema: permissionFormValidationSchema,
    fields: [
        {
            type: 'text',
            name: 'name',
            placeholder: 'permissions.createGroupModal.placeholder',
            maxLength: 40,
        },
    ],
};
